import fetchJSON from '@api/api_helper';

const getUrl = (attachmentKey) => `/api/v4/attachments/${attachmentKey}/reservations`;

export default (options, updateFetchControllers) => (
  fetchJSON(getUrl(options.attachmentKey), options, updateFetchControllers)
);

export const postReservations = (options, updateFetchControllers) => {
  const url = getUrl(options.attachmentKey);
  const data = {
    status: options.updatedStatus,
    note: options.checkinCheckoutNote
  };
  const appendedOptions = {
    body: { data: { attributes: data } },
    method: 'POST'
  };

  if (options.params) {
    appendedOptions.params = options.params;
  }

  return fetchJSON(url, appendedOptions, updateFetchControllers);
};
